module.exports = __webpack_public_path__ + "static/media/img1.b4d79892.jpg";